var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.submissionUrl),expression:"submissionUrl"}],staticClass:"text-center"},[_c('embed',{attrs:{"src":_vm.submissionUrl +
        '#navpanes=0&scrollbar=0&statusbar=0&view=fitH&zoom=scale',"width":"800","height":"800"}})])}
var staticRenderFns = []

export { render, staticRenderFns }